import './InfoHeader.css'

export default function InfoHeader () {
    return(
        <div className="info-header">
            <img className="info-header-logo" src="assets/logo.png" />
        </div>
    )
}